import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

import Container from "react-bootstrap/Container";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import AppNavbar from "./components/AppNavbar";
import ProtectedRoute from "./components/ProtectedRoute";

// Páginas públicas y de uso frecuente: import estático para el bundle inicial
import Home from "./components/Home";
import Login from "./components/Login";
import Register from "./components/Register";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import PageNotFound from "./components/404";

// Páginas protegidas pesadas (PDF, Excel, datatables, mapas, cámara): lazy-load
const Profile = React.lazy(() => import("./components/Profile"));
const BoardUser = React.lazy(() => import("./components/BoardUser"));
const BoardModerator = React.lazy(() => import("./components/BoardModerator"));
const BoardAdmin = React.lazy(() => import("./components/BoardAdmin"));
const Ofertas = React.lazy(() => import("./components/Ofertas"));
const Cobros = React.lazy(() => import("./components/Cobros"));
const ControlFotos = React.lazy(() => import("./components/ControlFotos"));
const PruebasCamara = React.lazy(() => import("./components/PruebasCamara"));
const Carrito = React.lazy(() => import("./components/Carrito"));
const Pedidos = React.lazy(() => import("./components/Pedidos"));
const ImprimirEtiquetas = React.lazy(() =>
  import("./components/ImprimirEtiquetas")
);
const Permisos = React.lazy(() => import("./components/Permisos"));
const TablaPermisos = React.lazy(() => import("./components/TablaPermisos"));
const Usuarios = React.lazy(() => import("./components/Usuarios"));
const Cheques = React.lazy(() => import("./components/Cheques"));
const EmpleadosAdmin = React.lazy(() => import("./components/EmpleadosAdmin"));
const HistoricoCajas = React.lazy(() => import("./components/HistoricoCajas"));
const ClientesInactivos = React.lazy(() =>
  import("./components/ClientesInactivos")
);
const OrdenDeDia = React.lazy(() => import("./components/OrdenDeDia"));
const ArticulosTienda = React.lazy(() =>
  import("./components/Tienda/ArticulosTienda")
);
const ProductoDetalle = React.lazy(() =>
  import("./components/Tienda/ProductoDetalle")
);
const MisPrecios = React.lazy(() => import("./components/Tienda/MisPrecios"));

const PageLoader = () => (
  <div className="d-flex justify-content-center align-items-center py-5">
    <div className="spinner-border" role="status">
      <span className="visually-hidden">Cargando...</span>
    </div>
  </div>
);

const App = () => {
  return (
    <>
      <AppNavbar />
      <Container fluid className="main-container">
        <div>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
              <Route path="/articulos" element={<ProtectedRoute><Navigate to="/tienda" replace /></ProtectedRoute>} />
              <Route path="/tienda" element={<ProtectedRoute><ArticulosTienda /></ProtectedRoute>} />
              <Route path="/tienda/:id" element={<ProtectedRoute><ProductoDetalle /></ProtectedRoute>} />
              <Route path="/mis-precios" element={<ProtectedRoute><MisPrecios /></ProtectedRoute>} />
              <Route path="/ofertas" element={<ProtectedRoute><Ofertas /></ProtectedRoute>} />
              <Route path="/empleado" element={<ProtectedRoute><BoardModerator /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute><BoardAdmin /></ProtectedRoute>} />
              <Route path="/forgotpassword" element={<ForgotPassword />} />
              <Route path="/resetpassword/:token" element={<ResetPassword />} />
              <Route path="/pruebas" element={<PruebasCamara />} />
              <Route path="/cart" element={<ProtectedRoute><Carrito /></ProtectedRoute>} />
              <Route path="/pedidos" element={<ProtectedRoute><Pedidos /></ProtectedRoute>} />
              <Route path="/etiquetas" element={<ProtectedRoute><ImprimirEtiquetas /></ProtectedRoute>} />
              <Route path="/admin/permisos" element={<ProtectedRoute><Permisos /></ProtectedRoute>} />
              <Route
                path="/admin/permisos/editar/:id"
                element={<ProtectedRoute><TablaPermisos /></ProtectedRoute>}
              />
              <Route path="/admin/usuarios" element={<ProtectedRoute><Usuarios /></ProtectedRoute>} />
              <Route path="/admin/cobros" element={<ProtectedRoute><Cobros /></ProtectedRoute>} />
              <Route path="/admin/fotosarticulos" element={<ProtectedRoute><ControlFotos /></ProtectedRoute>} />
              <Route path="/admin/cheques" element={<ProtectedRoute><Cheques /></ProtectedRoute>} />
              <Route path="/admin/historicocajas" element={<ProtectedRoute><HistoricoCajas /></ProtectedRoute>} />
              <Route path="/admin/empleados" element={<ProtectedRoute><EmpleadosAdmin /></ProtectedRoute>} />
              <Route path="/admin/clientesinactivos" element={<ProtectedRoute><ClientesInactivos /></ProtectedRoute>} />
              <Route path="/admin/ordendedia" element={<ProtectedRoute><OrdenDeDia /></ProtectedRoute>} />
              <Route path="*" element={<PageNotFound />} />
            </Routes>
          </Suspense>
        </div>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
      </Container>
    </>
  );
};

export default App;
